import React from 'react';
import { FormattedMessage } from 'react-intl';
import './validationMessageStyle.scss';

export const ValidationMessage = ({ errors = [], localize = true }) => {
  return (
    <div className=" text-danger validation-container w-100 d-flex justify-content-start px-3 pt-1 overflow-auto font-small">
      {errors?.map((er, index) => (
        <small key={index}>
          {localize ? <FormattedMessage id={er} /> : er}
          {index + 1 === errors.length ? '' : <>&nbsp; - &nbsp;</>}
        </small>
      ))}
    </div>
  );
};
